import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import styles from './styles.module.scss';

import Referral, { FBO } from '../Referral';
import LinkLang from '../../Wraps/LinkLang';
import { getReferralFromURL } from '../../../redux/actions/referralFromUrl';

import apiProductID from '../../../api/Product';
import apiSummary from '../../../api/Summary';
import ApiCart from '../../../api/Cart/CartApiFL';
import ApiReferral from '../../../api/Referral/ReferralApiFL';

import Config, { spanish } from '../../../config/config';

const Item = ({ item }) => {
  const [productID, setProductID] = useState(null);
  useEffect(async () => {
    setProductID(await apiProductID.getSKU(item?.idProducto));
  }, [item]);
  const image =
    productID && productID[0]
      ? productID[0]?.imageCatalog?.formats?.thumbnail?.url
      : '';
  return (
    image && (
      <div className={styles.item}>
        <div className={styles.itemImage}>
          <img src={Config.cdn.cdn_path + image} alt="product name" />
        </div>
        <div className={styles.itemInfo}>
          <b>{item?.NombreProducto}</b>
          <p>
            {spanish ? 'Producto' : 'Product'}# {item?.idProducto}
          </p>
          <span>
            {spanish ? 'Cantidad' : 'Quantity'}: {item?.Cantidad}
          </span>
        </div>
        <div className={styles.itemTotal}>
          <p>
            <NumberFormat
              value={item?.Total}
              thousandSeparator
              prefix="$"
              suffix=" MXN"
              displayType="text"
            />
          </p>
        </div>
      </div>
    )
  );
};

const Summary = ({
  edit,
  setReferalId,
  referralId,
  shippingCost,
  shippingTax,
  referralIdForm,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isCheckoutPayment =
    history.location.pathname ===
    `${spanish ? '/mex/es-mx' : '/mex/en-us'}/checkout/payment`;
  const [itemList, setItemList] = useState([]);
  const [orderInfo, setOrderInfo] = useState({});
  const [content, setContent] = useState(null);
  const [hasValidatedReferal, setHasValidatedReferal] = useState(false);
  const [isReferalValid, setIsReferalValid] = useState(true);
  const cartId = useSelector((globalState) => globalState.cartInfo.IdCarrito);
  const referralName = useSelector(
    (globalState) => globalState.referralInfo.referralName
  );
  const [referralIdShow, setReferralIdShow] = useState('');

  const getItemList = useCallback(async () => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      IdCarrito: cartId,
    };

    try {
      const resp = await ApiCart.getCart(payload);
      if (resp.Codigo === 200) {
        setItemList(resp.InfoCarrito[0].DetalleCarrito);
        setOrderInfo(resp.InfoCarrito[0]);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  const onReferalChangeHandler = (e) => {
    let value = e.target.value.replace(/-/g, '');
    value = value.replace(/(\d{3})(?=\d)/g, '$1-');
    setReferralIdShow(value);
    setReferalId(value.replaceAll('-', ''));
  };

  const validateReferal = async (e) => {
    e.preventDefault();
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      IdFbo: referralIdForm,
    };
    // console.log(payload);
    const resp = await ApiReferral.validateReferral(payload);
    // console.log(resp);
    setHasValidatedReferal(true);
    if (resp.Codigo === 200) {
      setIsReferalValid(resp.Respuesta[0].EsValido);
      if (resp.Respuesta[0].EsValido) {
        dispatch(
          getReferralFromURL(referralIdForm, resp.Respuesta[0].NombreFBO)
        );
      }
    }
    if (resp.Codigo !== 200 || !resp.Respuesta[0].EsValido) {
      setIsReferalValid(false);
    }
  };

  useEffect(async () => {
    setContent(await apiSummary.getContent());
    getItemList();
  }, []);

  const grandTotal =
    shippingCost && !isCheckoutPayment
      ? parseFloat(orderInfo?.Total) +
        parseFloat(shippingCost) +
        parseFloat(shippingTax)
      : orderInfo?.Total;

  const totalTaxes = isCheckoutPayment
    ? orderInfo?.Impuesto
    : parseFloat(orderInfo?.Impuesto) + parseFloat(shippingTax);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h5>{spanish ? content?.TitleSpanish : content?.TitleEnglish}</h5>
        <div className={styles.items}>
          {itemList?.map((item) => (
            <Item item={item} key={item.idProducto} />
          ))}
        </div>
        <div className={styles.breakdown}>
          <div>
            <p>Subtotal:</p>
            <p>
              <NumberFormat
                value={orderInfo?.Subtotal}
                thousandSeparator
                prefix="$"
                suffix=" MXN"
                displayType="text"
              />
            </p>
          </div>
          <div>
            <p>{spanish ? 'Impuestos' : 'Taxes'}:</p>
            <p>
              <NumberFormat
                value={!isCheckoutPayment ? totalTaxes?.toFixed(2) : totalTaxes}
                thousandSeparator
                prefix="$"
                suffix=" MXN"
                displayType="text"
              />
            </p>
          </div>
          <div>
            <p>{spanish ? 'Envío' : 'Shipping'}:</p>
            <p>{`$${shippingCost?.toFixed(2)} MXN`}</p>
          </div>
        </div>
        <div className={styles.total}>
          <div>
            <p>{spanish ? 'Total del pedido' : 'Grand Total'}:</p>
            <p>
              <NumberFormat
                value={grandTotal}
                thousandSeparator
                prefix="$"
                suffix=" MXN"
                displayType="text"
              />
            </p>
          </div>
        </div>
        {edit !== undefined ? (
          <div className={styles.edit}>
            <LinkLang to="/cart">
              {spanish ? content?.EditSpanish : content?.EditEnglish}
            </LinkLang>
          </div>
        ) : (
          ''
        )}
        {!referralId ? (
          <Referral
            spanish={spanish}
            text={
              spanish
                ? content?.FBOReferralSpanish
                : content?.FBOReferralEnglish
            }
            onChange={onReferalChangeHandler}
            onValidateReferral={validateReferal}
            hasValidatedReferal={hasValidatedReferal}
            isReferalValid={isReferalValid}
            referralName={referralName}
            button={
              spanish ? content?.FBOButtonSpanish : content?.FBOButtonEnglish
            }
            referralIdShow={referralIdShow}
          />
        ) : (
          <FBO
            spanish={spanish}
            referralId={referralId}
            referralName={referralName}
          />
        )}
      </div>
    </div>
  );
};

export default Summary;
